import React from 'react';
import { css, keyframes } from '@emotion/core';

import { functional, neutral600, neutral0 } from '@fever/ui';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';

export default function LoadingEditor() {
    return (
        <div css={css(loadingBackgroundStyle)}>
            <div css={css(wrapperStyle)}>
                <TrackChangesIcon css={css(logoStyle)} />
                <div css={css(containerStyle)}>
                    <ul css={css(scrollingTextStyle)}>
                        <li>
                            <span css={css(capsStyle)}>Inspire</span> them.
                        </li>
                        <li>
                            <span css={css(capsStyle)}>Amuse</span> them.
                        </li>
                        <li>
                            <span css={css(capsStyle)}>Quiz</span> them.
                        </li>
                        <li>
                            <span css={css(capsStyle)}>Move</span> them.
                        </li>
                        <li>
                            <span css={css(capsStyle)}>Go Viral.</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

const loadingBackgroundStyle = `
    background: ${neutral0};
    width: 100%;
    height: 100%;
    position: fixed;
`;

const wrapperStyle = `
    position: fixed;
    top: calc(50% - 74px);
    left: 0;
    right: 0;
    bottom: 0;
`;

const containerStyle = `
    height: 50px;
    color: ${neutral600};
    font-size: 40px;
    line-height: 50px;

    overflow: hidden;
    animation: colorchange 10s;
`;

const logoStyle = `
    font-size: 106px;
    width: 100%;
    color: ${functional};
`;

const cambiarStyle = keyframes`
    0% { margin-top: 0; }
    10% { margin-top: 0; }
    20% { margin-top: -50px; }
    30% { margin-top: -50px; }
    40% { margin-top: -100px; }
    50% { margin-top: -100px; }
    60% { margin-top: -150px; }
    70% { margin-top: -150px; }
    80% { margin-top: -200px; }
    90% { margin-top: -200px; }
    100% { margin-top: 0; }
`;

const scrollingTextStyle = css`
    padding-left: 10px;
    list-style: none;
    animation: ${cambiarStyle} 5s infinite;
    text-align: center;
`;

const capsStyle = `
    color: ${functional};
`;
